import React from 'react';
import { useSteps } from '@workday/upc-common';
import { LoginOTPVerify } from '../login/loginOTPVerify/LoginOTPVerify';
import { ResetAuthenticatorStep } from './authenticator/ResetAuthenticatorStep';
import { useHistory } from 'react-router-dom';
import { HOME_PATH } from '../../react-router-paths';

export function ResetAuthenticator() {
    const history = useHistory();
    const { currentStep, next } = useSteps();

    function onComplete() {
        history.push(HOME_PATH);
    }

    return currentStep === 0 ? (
        <LoginOTPVerify onNext={next} />
    ) : currentStep === 1 ? (
        <ResetAuthenticatorStep onNext={onComplete} />
    ) : null;
}
